export interface CredentialsDto {
  email: string;
  password: string;
}

export class ResetPasswordDto {
  email!: string;
  current_pass!: string;
  new_pass_first!: string;
  new_pass_second!: string;
}

export class AdminResetPasswordDto {
  adminEmail!: string;
  userEmail!: string;
  adminPassword!: string;
  newPassword!: string;
}

export interface AuthenticationResponse {
  access_token: string;
  status: string;
}

export interface AuthApiResponse {
  access_token?: string;
}

export interface EdgeApiResponse {
  authToken?: string;
}

export interface UserData {
  createdAt: Date;
  email: string;
  external_id: string;
  id: string;
  updatedAt: Date;
}

export interface UserDataResponse {
  data: UserData;
  status: string;
}

export interface LogoutResponse {
  success: string;
}

export class UpdateEdgePasswordDto {
  token!: string;
  password!: string;
  currentPassword!: string;
}